import React from "react";

import "./skills.css";
import Blockchain from "./Blockchain";
import Frontend from "./Frontend";
import Backend from "./Backend";
import VersionControl from "./VersionControl";
import AI from "./AI";

const Skills = () => {
  return (
    <section className="skill section" id="skills">
      <h2 className="section__title">Skills</h2>
      <span className="section__subtitle">My Tech Stack</span>

      <div className="skills__container container">
        <AI />
        <Blockchain />
        <Backend />
        <Frontend />
        <VersionControl />
      </div>
    </section>
  );
};

export default Skills;
